/* eslint-disable jsx-a11y/anchor-is-valid */

const Pagination = (props) => {

    const {
        page,
        hasNextPage,
        onPreviousClick,
        onNextClick,
        totalCount,
        pageSize,
        onPageChange
    } = props

    const totalPages = totalCount && pageSize ? Math.ceil(totalCount / pageSize) : 0;

    if (!totalCount || !onPageChange) {
        return (
            <>
                <ul className="pagination">
                    <li className={`page-item previous ${page <= 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => onPreviousClick()}>
                            <i className="previous"></i>
                        </button>
                    </li>
                    <li className={`page-item next ${hasNextPage ? '' : 'disabled'}`} >
                        <button className="page-link" onClick={() => onNextClick()}>
                            <i className="next"></i>
                        </button>
                    </li>
                </ul>

            </>
        );
    }

    const pages = [];
    const delta = 2; // Number of pages to show around current page

    for (let i = 1; i <= totalPages; i++) {
        if (
            i === 1 ||
            i === totalPages ||
            (i >= page - delta && i <= page + delta)
        ) {
            pages.push(i);
        } else if (
            pages[pages.length - 1] !== '...' &&
            pages[pages.length - 1] !== i - 1
        ) {
            pages.push('...');
        }
    }

    return (
        <ul className="pagination">
            <li className={`page-item previous ${page <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => onPageChange(page - 1)}>
                    <i className="previous"></i>
                </button>
            </li>

            {pages.map((p, i) => (
                <li key={i} className={`page-item ${p === page ? 'active' : ''} ${p === '...' ? 'disabled' : ''}`}>
                    {p === '...' ? (
                        <span className="page-link">...</span>
                    ) : (
                        <button className="page-link" onClick={() => onPageChange(p)}>
                            {p}
                        </button>
                    )}
                </li>
            ))}

            <li className={`page-item next ${page >= totalPages ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => onPageChange(page + 1)}>
                    <i className="next"></i>
                </button>
            </li>
        </ul>
    );
}

export { Pagination };
